import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { OuiTagModule } from 'omnium-ui/tag';
import { ViewerObjective } from '../../../../../../core/models/api.models';
import {
  formatCurrency,
  formatNumber,
  formatText
} from '../../investor-viewer-format.utils';
import { InvestorViewerAccordionComponent } from '../investor-viewer-accordion/investor-viewer-accordion.component';

@Component({
  selector: 'dbw-investor-viewer-objectives-section',
  imports: [OuiTagModule, InvestorViewerAccordionComponent],
  templateUrl: './investor-viewer-objectives-section.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../investor-viewer-section.shared.scss'
})
export class InvestorViewerObjectivesSectionComponent {
  readonly objectives = input.required<ViewerObjective[]>();

  protected readonly formatText = formatText;
  protected readonly formatNumber = formatNumber;
  protected readonly formatCurrency = formatCurrency;
}
